
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M4.5 2.018c0 .581-.208 1.064-.624 1.45-.416.385-.964.577-1.644.577h-.026c-.65 0-1.18-.194-1.59-.582A1.908 1.908 0 010 2.018C0 1.438.21.956.628.574 1.048.19 1.594 0 2.268 0c.662 0 1.196.191 1.604.574.407.382.616.864.628 1.444zM.378 5.882h3.744v11.411H.378V5.883zm9.747 4.787v6.624H6.372V8.461a157.76 157.76 0 01-.061-2.579h3.691l.123 1.579a4.746 4.746 0 011.45-1.415A3.59 3.59 0 0113.5 5.52c1.348 0 2.435.453 3.26 1.359.827.905 1.24 2.169 1.24 3.79v6.624h-3.753V11.04c0-.874-.189-1.522-.567-1.945-.378-.422-.868-.634-1.472-.634-.598 0-1.094.191-1.49.574-.395.382-.593.927-.593 1.634z"}})])
          )
        }
      }
    